/** @format */

import {styled, Box, Typography, Grid2 as Grid} from '@mui/material';

export const Root = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});


export const CounterText = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  color: theme.palette.semantic_dark?.surface.onSurfaceLight,
}));

export const CardsGrid = styled(Grid)({
  width: '100%',
});

